var _path, _rect, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoan(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.875 11.375L28.6818 12.0341H25L25.1932 11.375H28.875ZM27.1477 15.8182L25.0682 13.2727L25.0568 12.7955H26.0909C26.3598 12.7955 26.589 12.7576 26.7784 12.6818C26.9678 12.6042 27.1127 12.4886 27.2131 12.3352C27.3134 12.1799 27.3636 11.9848 27.3636 11.75C27.3636 11.4034 27.2595 11.1316 27.0511 10.9347C26.8428 10.7358 26.5227 10.6364 26.0909 10.6364H25L25.1932 10H26.0909C26.553 10 26.9318 10.0767 27.2273 10.2301C27.5246 10.3816 27.7443 10.59 27.8864 10.8551C28.0303 11.1184 28.1023 11.4167 28.1023 11.75C28.1023 12.0511 28.036 12.3286 27.9034 12.5824C27.7727 12.8343 27.5625 13.0369 27.2727 13.1903C26.9848 13.3438 26.6042 13.4205 26.1307 13.4205H26.1136L28.0341 15.7727V15.8182H27.1477ZM28.875 10L28.6818 10.6591L25.7841 10.6364L25.9773 10H28.875Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 21.5,
    width: 4,
    height: 12,
    rx: 0.5,
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 23C9.83333 23 10.9 22.7 12.5 21.5C14.5 20 16.5 16.5 17.5 16C18.3 15.6 19.8333 15.5 20.5 15.5L21.5 18C25 18 32.1 18 32.5 18C33.5 18 35 18.5 35 20C35 21.2 33.6667 22.1667 33 22.5C33.5 23 34.5 23.6411 34.5 25C34.5 26 33.1667 26.6667 32.5 27C33.1667 27.3333 34.5 28.3 34.5 29.5C34.5 31 33 31.5 32 31.5C33 32 34 34.7 32 35.5C31 36 22.6194 35.5 19 35.5C16.5 35.5 13.5 34 9.5 32",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 18L20.5 8.5H33.5L32 18",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 16.5L18.5 6.5H33L32.5 8",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoan);
export default __webpack_public_path__ + "static/media/Loan.c12fcb3f12331bf0dac9773d0ae2bd81.svg";
export { ForwardRef as ReactComponent };